import spinner from '../assets/spinner.png';

function SuspenseContent() {
	return (
		<div className="flex h-screen w-full items-center justify-center text-base-300 dark:text-base-200">
			<img className="rotate" src={spinner} alt="loading" />
		</div>
	);
}

export default SuspenseContent;
